import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import th from './locales/th.json'

export const DEFAULT_LANGUAGE = 'th'

void i18n.use(initReactI18next).init({
  fallbackLng: DEFAULT_LANGUAGE,
  lng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    th: {
      translation: th,
    },
    en: {
      translation: en,
    },
  },
})

export default i18n
